import { render, staticRenderFns } from "./modalForm.vue?vue&type=template&id=75404815&scoped=true"
import script from "./modalForm.vue?vue&type=script&lang=js"
export * from "./modalForm.vue?vue&type=script&lang=js"
import style0 from "./modalForm.vue?vue&type=style&index=0&id=75404815&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75404815",
  null
  
)

export default component.exports